import React, { useEffect, useState } from "react";
import { Box, Button, Card, CardContent, Typography } from "@mui/material";
import { generateQrWithLogo } from "../../utils/qr";
import logoImg from "../../assets/images/Logo2.png";

const ClaimReceipt = ({ qrPayload, onGoToHistory, isMobile, onBack }) => {
  const [qrUrl, setQrUrl] = useState("");
  const ref = qrPayload?.ref || "";

  useEffect(() => {
    let mounted = true;
    (async () => {
      try {
        if (!qrPayload) return;
        const url = await generateQrWithLogo(qrPayload, logoImg);
        if (mounted) setQrUrl(url);
      } catch (e) {
        console.error("Failed to generate QR:", e);
      }
    })();
    return () => { mounted = false; };
  }, [qrPayload]);

  const handleDownload = () => {
    if (!qrUrl) return;
    const link = document.createElement('a');
    link.href = qrUrl;
    link.download = `${ref || 'claim-qr'}.png`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <Card
      sx={{
        position: "absolute",
        width: "100%",
        height: "100%",
        backfaceVisibility: "hidden",
        transform: "rotateY(180deg)",
        top: 0,
        left: 0,
        borderRadius: "24px",
        boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.05)",
        bgcolor: "#FFFFFF",
        border: "1px solid #E8F3E0",
        display: 'flex',
        flexDirection: 'column',
        overflow: 'hidden',
      }}
    >
      <CardContent sx={{ p: 4, flex: 1, overflowY: 'auto', minHeight: 0 }}>
        <Typography sx={{ fontFamily: 'Poppins, Helvetica', color: '#516d4f', mb: 3 }}>
          Show this QR or reference to GSO when claiming your item.
        </Typography>
        <Box sx={{ display: 'flex', justifyContent: 'center' }}>
          {qrUrl && (
            <img src={qrUrl} alt="Claim QR" style={{ width: '100%', maxWidth: 340, height: 'auto', borderRadius: 12, boxShadow: '0 2px 12px rgba(0,0,0,0.08)' }} />
          )}
        </Box>
        <Typography sx={{ fontFamily: 'Poppins, Helvetica', color: '#516d4f', mt: 2, textAlign: 'center' }}>
          Reference: <strong>{ref}</strong>
        </Typography>
      </CardContent>
      <Box sx={{ display: 'flex', gap: 2, justifyContent: 'center', p: 3, borderTop: '1px solid #E8F3E0', bgcolor: '#fff' }}>
        <Button
          variant="outlined"
          onClick={onBack}
          sx={{
            borderColor: '#516d4f',
            color: '#516d4f',
            borderRadius: '12px',
            px: 4,
            py: 1.5,
            textTransform: 'none',
            fontFamily: 'Poppins, Helvetica',
            '&:hover': {
              borderColor: '#344b35',
              bgcolor: 'rgba(81, 109, 79, 0.05)',
            },
          }}
        >
          Back
        </Button>
        <Button
          variant="contained"
          onClick={handleDownload}
          sx={{
            bgcolor: '#344b35',
            color: '#ffffff',
            borderRadius: '12px',
            px: 4,
            py: 1.5,
            textTransform: 'none',
            fontFamily: 'Poppins, Helvetica',
            '&:hover': {
              bgcolor: '#2a3c2a',
            },
          }}
        >
          Download QR
        </Button>
        <Button
          variant="text"
          onClick={onGoToHistory}
          sx={{ color: '#516d4f' }}
        >
          Go to Claim History
        </Button>
      </Box>
    </Card>
  );
};

export default ClaimReceipt;
